import type { CharacterDefinition } from '../../game/content/characters';

export function dangerCoreTopY(
  bodyY: number,
  bodyAngle: number,
  baseSize: number,
  core: CharacterDefinition['dangerCore'],
): number {
  const scaledOffsetX = core.offsetX * baseSize;
  const scaledOffsetY = core.offsetY * baseSize;
  const rotatedOffsetY = scaledOffsetX * Math.sin(bodyAngle) + scaledOffsetY * Math.cos(bodyAngle);
  return bodyY + rotatedOffsetY - core.radiusRatio * baseSize;
}
